import React from "react";
import Sidebar from "./Sidebar";
import AppLoading from "./AppLoading";
import useSidebarState from "../hooks/useSidebarState";
import { useAuth } from "../contexts/AuthContext";
import { useLanguage } from "../contexts/LanguageContext";
import PayrollWorkspace from "./Payroll/PayrollWorkspace";
import useCompanyPayroll from "./Payroll/useCompanyPayroll";
import "./Home.css";
import "./MyTeam.css";

export default function Payroll() {
  const [collapsed, setCollapsed] = useSidebarState();
  const { currentUser } = useAuth();
  const { isRTL } = useLanguage();
  const company = useCompanyPayroll();
  return (
    <div className="payroll-product">
      <Sidebar collapsed={collapsed} onToggle={setCollapsed} />
      <main className="home-body payroll-main" dir={isRTL ? "rtl" : "ltr"}>
        {company.loading ? (
          <AppLoading inline label="Loading payroll…" />
        ) : !company.allowed ? (
          <p>
            Payroll permission and access to all departments are required to
            open payroll.
          </p>
        ) : !company.companyId || !company.ready ? (
          <section className="payroll-unavailable">
            <h2>Payroll setup</h2>
            <p role="alert">
              {company.error || "Your payroll workspace could not be loaded."}
            </p>
            <button className="post-job-cta" onClick={company.reload}>
              Try again
            </button>
          </section>
        ) : (
          <>
            {company.error && <p role="alert">{company.error}</p>}
            <PayrollWorkspace
              key={`${company.companyId}:${currentUser.uid}`}
              company={company}
              storageKey={`jobseeqr-payroll-preview-v2:${company.companyId}:${currentUser.uid}`}
            />
          </>
        )}
      </main>
    </div>
  );
}
